import axios from 'axios';

const BankStatementCollectionService = {
  async updateBankStatementCollection({ formValues, id }) {
    const response = await axios.patch(
      `/bank-statement-collections/${id}`,
      formValues
    );

    return response.data;
  },
};

export default BankStatementCollectionService;
